<template>
  <b-list-group-item>
    {{catitem.name}}
    <a style="float: right;" :href="'#'+$route.path">
      <b-icon icon="x-circle" variant="danger" font-scale="1.5" v-b-popover.hover.right="'Remove Item from Category'" @click="removeCategoryItem"></b-icon>
    </a>
  </b-list-group-item>
</template>
<script>
export default {
  name: 'CategoryItem',
  props: ['catitem', 'category_id', 'totalcatitems'],
  data () {
    return {

    }
  },

  computed: {

  },

  methods: {
    emitRefreshItems() {
      this.$emit('emit-refresh-items');
    },

    emitSwitchOverlay(bool) {
      this.$emit('emit-switch-overlay', bool);
    },

    async removeCategoryItem() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      // update order with status of 'ready'
      const { data } = await this.$api.delete('categories/'+this.category_id+'/items/'+this.catitem.id,
        config
      );
      if (data.deleted == true) {
        this.emitRefreshItems();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem removing the item from the category, please try again later.', {
          title: 'Error removing item',
          centered: true
        })
      }
    },

  },
}
</script>

<style>
</style>
